import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import DashboardLayout from "../components/DashboardLayout";
import PageCallToAction from "../components/PageCallToAction";
import { cn } from "@/lib/utils";

const DemoList = () => {
  return (
    <DashboardLayout>
      <Helmet>
        <title>Demos | OpenPipe</title>
        <meta
          name="description"
          content="Explore our latest demos and compare RL agents to SOTA models."
        />
      </Helmet>
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Interactive Demos</h1>
        <div className="grid gap-6">
          <DemoListItem
            title="Tic Tac Toe"
            description="Play Tic Tac Toe with an LLM"
            demoId="tic-tac-toe"
          />
        </div>

        <PageCallToAction />
      </div>
    </DashboardLayout>
  );
};

export default DemoList;

const DemoListItem = ({
  title,
  description,
  demoId,
}: {
  title: string;
  description: string;
  demoId: string;
}) => {
  return (
    <Link
      to={`/demos/${demoId}`}
      className={cn(
        "block p-6 rounded-lg border border-border bg-card hover:bg-accent/50 transition-colors",
        "group"
      )}
    >
      <div className="space-y-2">
        <h2 className="text-xl font-semibold text-foreground group-hover:text-primary transition-colors">
          {title}
        </h2>
        <p className="text-muted-foreground">{description}</p>
      </div>
    </Link>
  );
};
